




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { fetchCambioServicio } from './fetchCambioServicio';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';

@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class CambioSIM extends Vue {
  constructor() {
    super();
  }

  @Prop({ default: null }) accion_modal: any;
  @Prop({ default: null }) envio_tecnico: any;
  @Prop({ default: null }) simserienumero_od: any;
  @Prop({ default: null }) titulo: any;
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify;
  editar: any;

  formFields: FormFieldDefMap = {
    sim_serie_numero_new: {
      label: 'Sim Serie Número Nuevo*',
      id: '',
      value: '',
    },
    sim_estado_new: {
      label: 'Sim Estado',
      id: '',
      value: '',
    },
  };

  async tomar_estado() {
    this.loadingService.showLoading();
    return fetchCambioServicio(
      {
        simnumero: this.formFields.sim_serie_numero_new.value,
        tecnicoid_r: this.envio_tecnico,
        editando: this.editar,
      },
      'conectaCambioServicio/get_simestado'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          let res = data.data.data[0]['estado'];
          this.formFields.sim_estado_new.value = res;
        } else {
          this.loadingService.hideLoading();
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  @Watch('formFields')
  onModelTipoCambioChanged(val: any, oldVal: any) {
    this.$emit('input', this.formFields);
  }

  mounted() {
    if (this.accion_modal == 'EDITAR') {
      this.formFields.sim_serie_numero_new.value = this.simserienumero_od;
      this.editar = 'Editar';
      this.tomar_estado();
    }
  }
} //end class
